export default __webpack_public_path__ + "static/media/abuad-alumni-logo.d11ccd95.png";